var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',{staticClass:"page-title"},[_vm._v("Welcome Admin!")]),_c('ul',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Dashboard")])])])])])
}]

export { render, staticRenderFns }